import React, { useState } from 'react';
import LoginPage from './pages/LoginPage';
import VisitListPage from './pages/VisitListPage';
import ResultPage from './pages/ResultPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AdminDatKhamPage from './pages/AdminDatKhamPage';
import AdminCongTyPage from './pages/AdminCongTyPage';
import AdminImportKskPage from './pages/AdminImportKskPage';
import AdminPrintKskPage from './pages/AdminPrintKskPage';
import BookingPage from './pages/BookingPage';
import { AuthService } from './services/api';

// Trang đặt khám công khai — KHÔNG yêu cầu đăng nhập (đường dẫn /datkham)
const isBookingRoute = () => {
  const p = (window.location.pathname || '').toLowerCase();
  return p === '/datkham' || p.startsWith('/datkham/');
};

// Link tra cứu công khai /kq/{token} — token = mã lượt khám đã mã hóa (share-link/QR),
// KHÔNG yêu cầu đăng nhập. Token đi qua ResultService dưới định danh 'pub:<token>'.
const publicResultToken = () => {
  const m = (window.location.pathname || '').match(/^\/kq\/([^/]+)$/i);
  return m ? decodeURIComponent(m[1]) : null;
};

export default function App() {
  // Public pages are fully standalone (no auth gate, no hooks below run).
  if (isBookingRoute()) return <BookingPage />;
  const shareToken = publicResultToken();
  if (shareToken) return <ResultPage maLuotKham={'pub:' + shareToken} />;
  return <MainApp />;
}

function MainApp() {
  const [user, setUser] = useState(() => AuthService.getUser());
  const [view, setView] = useState('visits'); // 'visits' | 'result' | 'changePw' | 'admin' | 'adminDatkham' | 'adminCongTy'
  const [fromCongTy, setFromCongTy] = useState(false); // kết quả đang mở từ màn hình công ty
  const [selectedVisit, setSelectedVisit] = useState(null);
  // Đã auto-mở kết quả (trường hợp chỉ có 1 lượt khám) — tránh loop khi bấm Quay lại
  const [autoOpenedVisit, setAutoOpenedVisit] = useState(false);

  const handleLogin = (userData) => {
    setUser(userData);
    setSelectedVisit(null);
    setAutoOpenedVisit(false);
    setView('visits');
  };

  const handleLogout = () => {
    AuthService.logout();
    setUser(null);
    setSelectedVisit(null);
    setView('visits');
  };

  const handleSelectVisit = (maLuotKham) => {
    setFromCongTy(false);
    setSelectedVisit(maLuotKham);
    setView('result');
  };

  // Mở kết quả 1 nhân viên từ màn hình tra cứu công ty
  const handleSelectVisitFromCongTy = (maLuotKham) => {
    setFromCongTy(true);
    setSelectedVisit(maLuotKham);
    setView('result');
  };

  const backToVisits = () => {
    setSelectedVisit(null);
    if (fromCongTy) {
      setFromCongTy(false);
      setView('adminCongTy');
    } else {
      setView('visits');
    }
  };

  if (!user) return <LoginPage onLogin={handleLogin} />;

  if (view === 'changePw')
    return <ChangePasswordPage user={user} onBack={backToVisits} />;

  if (view === 'admin' && user.isAdmin)
    return <AdminUsersPage onBack={backToVisits} />;

  if (view === 'adminDatkham' && user.isAdmin)
    return <AdminDatKhamPage onBack={backToVisits} />;

  if (view === 'adminCongTy' && user.isAdmin)
    return <AdminCongTyPage onBack={() => setView('visits')} onSelectVisit={handleSelectVisitFromCongTy} />;

  if (view === 'adminImportKsk' && user.isAdmin)
    return <AdminImportKskPage onBack={() => setView('visits')} />;

  if (view === 'adminPrintKsk' && user.isAdmin)
    return <AdminPrintKskPage onBack={() => setView('visits')} />;

  if (view === 'result' && selectedVisit)
    return <ResultPage user={user} maLuotKham={selectedVisit} onLogout={handleLogout} onBack={backToVisits} />;

  return (
    <VisitListPage
      user={user}
      onLogout={handleLogout}
      onSelectVisit={handleSelectVisit}
      onChangePassword={() => setView('changePw')}
      onOpenAdmin={() => setView('admin')}
      onOpenDatKhamAdmin={() => setView('adminDatkham')}
      onOpenCongTy={() => setView('adminCongTy')}
      autoSelectSingle={!autoOpenedVisit}
      onAutoSelectVisit={(ma) => { setAutoOpenedVisit(true); handleSelectVisit(ma); }}
      onOpenImportKsk={() => setView('adminImportKsk')}
      onOpenPrintKsk={() => setView('adminPrintKsk')}
    />
  );
}
